import axios from "axios";
import { error } from "@/utils/notifications";

import { merge } from "lodash";

console.log("Dev env:", import.meta.env.QUASAR_DEBUG);
console.log(import.meta.env.API_URL);

axios.defaults.withCredentials = true;

const axiosHandler = axios.create({
  baseURL: import.meta.env.API_URL,
  withCredentials: true,
  crossDomain: true,
});

const useFetch = false;

const processUrl = (url) => {
  if (url.indexOf("http") == -1 && url.indexOf("https") == -1) {
    return import.meta.env.API_URL + url;
  }

  return url;
};

const axiosRequest = (method, url, payload, _options) => {
  return new Promise((resolve, reject) => {
    const showErrors =
      _options && _options.showErrors !== undefined
        ? _options.showErrors
        : true;
    if (_options && _options.showErrors !== undefined)
      delete _options.showErrors;

    const options = merge(
      {
        method,
        url,
      },
      _options,
    );

    if (payload) {
      if (typeof payload === "object") {
        options.headers = {
          "Content-Type": "application/json",
        };
      } else {
        options.headers = {
          "Content-Type": "text/csv",
        };
      }

      options.data = payload;
    }

    axiosHandler(options)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (showErrors) {
          console.error(
            "HTTP error: " + err.toString(),
            options.method,
            options.url,
            err.response !== undefined
              ? err.response.data.message
              : "no response",
          );
          error(
            err.response !== undefined
              ? err.response.data.message
              : "Error occured",
          );
        }
        reject(
          err.response !== undefined
            ? err.response.data.message
            : "Error occured",
          err.response,
        );
      });
  });
};

const fetchRequest = (method, url, payload, _options) => {
  return new Promise((resolve, reject) => {
    const showErrors =
      _options && _options.showErrors !== undefined
        ? _options.showErrors
        : true;

    if (_options && _options.showErrors !== undefined)
      delete _options.showErrors;

    const options = merge(
      {
        method: method,
        mode: "cors",
        credentials: "include",
      },
      _options,
    );

    if (payload) {
      if (typeof payload === "object") {
        options.headers = {
          "Content-Type": "application/json",
        };
        options.body = JSON.stringify(payload);
      } else {
        options.headers = {
          "Content-Type": "text/csv",
        };
        options.body = payload;
      }
    }

    fetch(url, options)
      .then(async (response) => {
        let data = {};

        try {
          data = await response.json();
        } catch (err) {
          // body is not valid JSON — keep the default
        }

        const headers = {};

        response.headers.forEach((val, key) => {
          headers[key] = val;
        });

        resolve({
          status: response.status,
          statusText: response.statusText,
          headers: headers,
          data: data,
        });
      })
      .catch((err) => {
        if (showErrors) {
          console.error(err);
          error(
            err.response !== undefined
              ? err.response.data.message
              : "Error occured",
          );
        }
        reject(
          err.response !== undefined
            ? err.response.data.message
            : "Error occured",
          err,
        );
      });
  });
};

export default {
  get: (url, options) => {
    if (useFetch) {
      // FETCH API
      return fetchRequest("GET", processUrl(url), undefined, options);
    } else {
      // AXIOS
      return axiosRequest("get", processUrl(url), undefined, options);
    }
  },
  post: (url, payload) => {
    if (useFetch) {
      // FETCH API
      return fetchRequest("POST", processUrl(url), payload);
    } else {
      // AXIOS
      return axiosRequest("post", processUrl(url), payload);
    }
  },
  put: (url, payload) => {
    if (useFetch) {
      // FETCH API
      return fetchRequest("PUT", processUrl(url), payload);
    } else {
      // AXIOS
      return axiosRequest("put", processUrl(url), payload);
    }
  },
  patch: (url, payload) => {
    if (useFetch) {
      // FETCH API
      return fetchRequest("PATCH", processUrl(url), payload);
    } else {
      // AXIOS
      return axiosRequest("patch", processUrl(url), payload);
    }
  },
  delete: (url, payload) => {
    if (useFetch) {
      // FETCH API
      return fetchRequest("DELETE", processUrl(url), payload);
    } else {
      // AXIOS
      return axiosRequest("delete", processUrl(url), payload);
    }
  },
  fetchExport: (endpoint, progressCallback, doneCallback, payload) => {
    const options = {
      method: "get",
      mode: "cors",
      credentials: "include",
    };

    if (payload) {
      options.method = "post";
      options.headers = {
        "Content-Type": "application/json",
      };
      options.body = JSON.stringify(payload);
    }

    fetch(import.meta.env.API_URL + endpoint, options)
      .then(async (response) => {
        const utf8Decoder = new TextDecoder("utf-8");
        // response.headers.forEach((val, key) => {
        //   console.log(key + ":\t" + val);
        // });

        const reader = response.body.getReader();

        let { value: chunk, done: readerDone } = await reader.read();

        chunk = chunk ? utf8Decoder.decode(chunk) : "";

        const newline = /\r?\n/gm;
        let startIndex = 0;

        const lines = [];
        const totalLines = +response.headers.get("newsky-export-length");
        let readLines = 0;

        while (true) {
          const result = newline.exec(chunk);
          if (!result) {
            if (readerDone) break;
            const remainder = chunk.substr(startIndex);
            ({ value: chunk, done: readerDone } = await reader.read());
            chunk = remainder + (chunk ? utf8Decoder.decode(chunk) : "");
            startIndex = newline.lastIndex = 0;
            continue;
          }
          readLines++;

          const line = chunk.substring(startIndex, result.index);
          lines.push(line);
          if (progressCallback)
            progressCallback(
              {
                pct: readLines / totalLines,
                current: readLines,
                total: totalLines,
              },
              line,
            );

          startIndex = newline.lastIndex;
        }

        if (startIndex < chunk.length) {
          // Last line didn't end in a newline char
          readLines++;
          const line = chunk.substr(startIndex);
          lines.push(line);
          if (progressCallback)
            progressCallback(
              {
                pct: readLines / totalLines,
                current: readLines,
                total: totalLines,
              },
              line,
            );
        }

        if (doneCallback) doneCallback(lines);
      })
      .catch((err) => {
        if (doneCallback) doneCallback(err);
      });
  },
  sendImport: (endpoint, payload, progressCallback, doneCallback) => {
    const options = {
      method: "post",
      url: import.meta.env.API_URL + endpoint,
    };

    if (!payload) {
      if (doneCallback) doneCallback(false);
      return false;
    }

    if (typeof payload === "object") {
      options.headers = {
        "Content-Type": "application/json",
      };
    } else {
      options.headers = {
        "Content-Type": "text/csv",
      };
    }

    options.data = payload;

    options.onUploadProgress = (progressEvent) => {
      const { loaded, total } = progressEvent;
      progressCallback({
        pct: loaded / total,
        current: loaded,
        total: total,
      });
    };

    axiosHandler(options).then((response) => {
      if (doneCallback) doneCallback(response.data);
    });
  },
};
